'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactPagify = require('react-pagify');

var _reactPagify2 = _interopRequireDefault(_reactPagify);

var _segmentize = require('segmentize');

var _segmentize2 = _interopRequireDefault(_segmentize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Paginator = function Paginator(_ref) {
  var pagination = _ref.pagination,
      pages = _ref.pages,
      onSelect = _ref.onSelect;

  var styles = require('./Paginator.scss');

  return _react2.default.createElement(
    'div',
    { className: styles.root },
    _react2.default.createElement(
      _reactPagify2.default.Context,
      {
        className: 'enterprise-table-pagination',
        segments: (0, _segmentize2.default)({
          page: pagination.page,
          pages: pages,
          beginPages: 3,
          endPages: 3,
          sidePages: 2
        }), onSelect: onSelect
      },
      _react2.default.createElement(
        _reactPagify2.default.Button,
        { page: pagination.page - 1 },
        'Previous'
      ),
      _react2.default.createElement(_reactPagify2.default.Segment, { field: 'beginPages' }),
      _react2.default.createElement(_reactPagify2.default.Ellipsis, {
        className: 'ellipsis',
        previousField: 'beginPages',
        nextField: 'previousPages'
      }),
      _react2.default.createElement(_reactPagify2.default.Segment, { field: 'previousPages' }),
      _react2.default.createElement(_reactPagify2.default.Segment, { field: 'centerPage', className: 'selected-page' }),
      _react2.default.createElement(_reactPagify2.default.Segment, { field: 'nextPages' }),
      _react2.default.createElement(_reactPagify2.default.Ellipsis, {
        className: 'ellipsis',
        previousField: 'nextPages',
        nextField: 'endPages'
      }),
      _react2.default.createElement(_reactPagify2.default.Segment, { field: 'endPages' }),
      _react2.default.createElement(
        _reactPagify2.default.Button,
        { page: pagination.page + 1 },
        'Next'
      )
    )
  );
};
Paginator.propTypes = {
  pagination: _react.PropTypes.object.isRequired,
  pages: _react.PropTypes.number.isRequired,
  onSelect: _react.PropTypes.func.isRequired
};

exports.default = Paginator;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseTable/TableControls/Paginator/Paginator.jsx
// module id = 1612
// module chunks = 0